import Big from "big.js";
import { getLocaleWithFallback } from "./Extensions";
/**
 * Format a ISO date string to a none time local date string
 * @param dateToFormat
 * @returns
 */
export function formatDate(dateToFormat, localePassed = null) {
    //Get the local needed
    const usedLocale = localePassed ? localePassed : getLocaleWithFallback();
    let date = new Date(dateToFormat);
    return date.toLocaleDateString(usedLocale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}
/**
 * Format a ISO date string to a time local date string
 * @param dateToFormat
 * @returns
 */
export function formatDateWithTime(dateToFormat, localePassed = null) {
    //Get the local needed
    const usedLocale = localePassed ? localePassed : getLocaleWithFallback();
    let date = new Date(dateToFormat);
    return date.toLocaleDateString(usedLocale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
}
/**
 * Parses a date to a local date string
 * @param date
 * @returns
 */
export function dateAsString(date, localePassed = null) {
    //Get the local needed
    const usedLocale = localePassed ? localePassed : getLocaleWithFallback();
    return date.toLocaleDateString(usedLocale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}
/**
 * Get a date value from today without out time
 * @returns
 */
export function startOfToday() {
    let now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
export function addDaysToDate(oldDate, daysToAdd) {
    return new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate() + daysToAdd);
}
export function subtractSecondsFromDate(date, seconds) {
    date.setSeconds(date.getSeconds() - seconds);
    return date;
}
export function removeTimeFromDate(oldDate) {
    return new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate());
}
export function addYearsToDate(oldDate, yearsToAdd) {
    return new Date(oldDate.getFullYear() + yearsToAdd, oldDate.getMonth(), oldDate.getDate());
}
export function isoDateToInputFieldString(date) {
    if (date == null)
        return null;
    return parseDate(date).toLocaleString("en-us", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");
}
//This will parse a UTC date to a local date.
export function parseDate(inputString) {
    if (inputString.includes("-")) {
        let parts = inputString.split('-');
        // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
        return new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))); // Note: months are 0-based
    }
    else if (inputString.includes("/")) {
        let parts = inputString.split('.');
        // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
        return new Date(Date.UTC(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))); // Note: months are 0-based
    }
    else {
        let parts = inputString.split('.');
        // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
        return new Date(Date.UTC(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))); // Note: months are 0-based
    }
}
export function compareDate(dateA, dateB) {
    return new Date(dateA).getTime() - new Date(dateB).getTime();
}
export function formatBigWithLocale(big, localePassed = null, digits = 2) {
    //Get the locale needed
    const usedLocale = localePassed ? localePassed : getLocaleWithFallback();
    const usedDigits = digits != null ? digits : 2;
    const minUsedDigits = usedDigits >= 3 ? 3 : usedDigits;
    //Format the number
    const formatedNumber = (big || new Big(0))
        .toNumber()
        .toLocaleString(usedLocale, { minimumFractionDigits: minUsedDigits, maximumFractionDigits: usedDigits });
    //We have a fuckup for french CH
    if (usedLocale.startsWith("fr")) {
        return formatedNumber.replace(/\u202F/g, ' ');
    }
    else {
        return formatedNumber;
    }
}
export function formatNumberWithLocale(number, localePassed = null) {
    //Get the locale needed
    const usedLocale = localePassed ? localePassed : getLocaleWithFallback();
    return number.toLocaleString(usedLocale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
export function moneyRound(number) {
    let increment = new Big(0.05);
    return number.div(increment).round(0).times(increment);
}
export function roundToTwoDecimal(numberToRound) {
    let negative = numberToRound < 0;
    let rounded = Number(Math.round(Number(Math.abs(numberToRound) + "e2")) + "e-2");
    return negative ? rounded * -1 : rounded;
}
/**
 * Transform the given locale to a currency unit
 * @param currency
 * @returns
 */
export function currencyToCurrencySymbol(currency) {
    if (currency == "EUR") {
        return "€";
    }
    else {
        return "CHF";
    }
}
/**
 * Transform the current local to a compatible QR-Bill language.
 * @param locale The requested language
 * @returns A qr compatible language.
 */
export function localeaToQrLocale(locale) {
    if (locale.toLowerCase().includes("fr"))
        return "FR";
    else if (locale.toLowerCase().includes("en"))
        return "EN";
    else if (locale.toLowerCase().includes("it"))
        return "IT";
    else
        return "DE";
}
// Clamp number between two values with the following line:
export function clamp(num, min, max) { return Math.min(Math.max(num, min), max); }
